import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import * as actions from "../redux/MessageBoxAction";
import { CreateMessageBox } from "./CreateMessageBox";
import { MessageBoxDetail } from "./MessageBoxDetail";
import "./messageBoxList.css";

export default function MessageBoxList() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [swalProps, setSwalProps] = useState({});
  const [inboxId, setInboxId] = useState();

  const messageBoxState = useSelector(
    ({ messageBox }) => messageBox,
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getMemberInboxList({ action: "memberinboxlist" }));
  }, []);

  const handlePin = (inboxid, e) => {
    e.stopPropagation();
    dispatch(actions.pinInbox({ action: "pininbox", inboxid })).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        dispatch(actions.getMemberInboxList({ action: "memberinboxlist" }));
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  const updateStatus = (inboxid, e) => {
    e.stopPropagation();
    dispatch(
      actions.updateMessageStatus({ action: "inboxdisplaystatus", inboxid })
    ).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        dispatch(actions.getMemberInboxList({ action: "memberinboxlist" }));
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  const handleDelete = (inboxid, e) => {
    e.stopPropagation();
    setSwalProps({
      show: true,
      icon: "question",
      title: intl.formatMessage({ id: "confirmation" }),
      text: intl.formatMessage({ id: "questionRemoveSelectedPost" }),
      showCancelButton: true,
      onConfirm: () => {
        dispatch(
          actions.deleteInbox({
            action: "deleteinbox",
            inboxid,
          })
        ).then((resp) => {
          resp = resp.data;
          if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
            dispatch(actions.getMemberInboxList({ action: "memberinboxlist" }));
            setSwalProps({
              show: true,
              icon: "success",
              title: intl.formatMessage({ id: "success" }),
              text: intl.formatMessage({ id: "removePostSuccessfully" }),
            });
          } else {
            setSwalProps({
              show: true,
              icon: "error",
              title: intl.formatMessage({ id: "error" }),
              text: resp.message,
            });
          }
        });
      },
    });
  };

  return (
    <div>
      {messageBoxState.actionsLoading && (
        <div
          className="position-fixed w-100 top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
          style={{
            scale: "1.5",
            background: "rgba(0,0,0,0.3)",
            zIndex: "9999",
          }}
        >
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      )}
      <MessageBoxDetail
        setSwalProps={setSwalProps}
        setInboxId={setInboxId}
        inboxId={inboxId}
      />
      <SweetAlert2
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
        customClass="custom-swal"
      />
      <div className="d-flex justify-content-between align-items-center">
        <h2>{intl.formatMessage({ id: "messageBox" })}</h2>
        <CreateMessageBox setSwalProps={setSwalProps} />
      </div>
      <div
        className="d-flex flex-column gap-3 align-items-stretch mt-4"
        style={{ maxWidth: "800px" }}
      >
        {messageBoxState.memberInboxList?.memberInboxLists.map(
          (memberInboxList) => (
            <div
              key={memberInboxList.inboxid}
              className={`card card-css mb-3`}
              onClick={() => setInboxId(memberInboxList.inboxid)}
            >
              <div
                className={`px-3 py-2 border-bottom  d-flex justify-content-between align-items-center`}
              >
                <span className="fw-bold">{memberInboxList.title}</span>
                <div className="d-flex align-items-center gap-2">
                  <span className="small" style={{ color: "gray" }}>
                    {memberInboxList.lastdate}
                  </span>
                  {memberInboxList.unread === "true" && (
                    <span className="badge bg-warning text-dark">Unread</span>
                  )}
                  {memberInboxList.pinned === "true" ? (
                    <i className="bi bi-pin-angle-fill text-warning" />
                  ) : (
                    <i
                      title={intl.formatMessage({ id: "pinPost" })}
                      className="bi bi-pin-angle text-warning"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => handlePin(memberInboxList.inboxid, e)}
                    />
                  )}
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={memberInboxList.ispublic === "true"}
                      onClick={(e) => updateStatus(memberInboxList.inboxid, e)}
                    />
                  </div>
                  <i
                    title={intl.formatMessage({ id: "deletePost" })}
                    className="bi bi-trash3 text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleDelete(memberInboxList.inboxid, e)}
                  />
                </div>
              </div>
              <div className="card-body">
                <p className="card-text" style={{ whiteSpace: "pre-line" }}>
                  {memberInboxList.content}
                </p>

                <div
                  className="d-flex justify-content-end"
                  style={{ fontSize: "12px" }}
                >
                  {intl.formatMessage({ id: "totalComment" })} :{" "}
                  {memberInboxList.totalcomment}
                </div>
              </div>
            </div>
          )
        )}
      </div>
      {messageBoxState.memberInboxList?.memberInboxLists &&
        messageBoxState.memberInboxList?.memberInboxLists.length === 0 && (
          <div className="d-flex fw-bold align-items-center justify-content-center p-5">
            {intl.formatMessage({ id: "noPostFound" })}
          </div>
        )}
    </div>
  );
}
